(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[346],{

/***/ 78886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutoring/[...slug]",
      function () {
        return __webpack_require__(27987);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingPageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./components/LandingPageHero.module.scss
var LandingPageHero_module = __webpack_require__(2231);
var LandingPageHero_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageHero_module);
;// CONCATENATED MODULE: ./public/images/online-tutoring-bg-2.jpg
/* harmony default export */ var online_tutoring_bg_2 = ({"src":"/_next/static/media/online-tutoring-bg-2.400ce5c1.jpg","height":2880,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAgEAABAwMFAQAAAAAAAAAAAAACAAEDBQYSBBEhQUJR/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABYRAAMAAAAAAAAAAAAAAAAAAAAREv/aAAwDAQACEQMRAD8AlcV91iaomNK1jA0ZkxhGYM7D5yy72+cIiIyxUj//2Q==","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./components/HeroSearch.js + 3 modules
var HeroSearch = __webpack_require__(56665);
;// CONCATENATED MODULE: ./components/LandingPageHero.js






function LandingPageHero(param) {
    let { page  } = param;
    const backgroundStyle = {
        backgroundImage: page.coverPhoto.url || online_tutoring_bg_2.src
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LandingPageHero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LandingPageHero_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: backgroundStyle.backgroundImage,
                className: (LandingPageHero_module_default()).staticBg,
                alt: "Cover photo",
                priority: true,
                fill: true,
                sizes: "100vw",
                style: {
                    objectFit: "cover",
                    objectPosition: "center"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "".concat((LandingPageHero_module_default()).content, " pt-lg-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-2 pt-5 pb-lg-4 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-white pb-2",
                                children: page.header1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h5 text-white",
                                children: page.subheader
                            })
                        ]
                    }),
                    page.showSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-2 mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((LandingPageHero_module_default()).searchContainer, " p-3 p-lg-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSearch/* default */.Z, {
                                subject: page.subject,
                                level: page.level,
                                location: page.marketingLocation,
                                modality: page.modality
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
;// CONCATENATED MODULE: ./components/LandingPageContainer.js





function LandingPageContainer(param) {
    let { page , children  } = param;
    const showBreadcrumbs = page.cachedDepth > 0;
    const sortedAncestors = page.ancestors.sort((a, b)=>a.cachedDepth - b.cachedDepth);
    const linkPath = (ancestor)=>{
        switch(ancestor.slug){
            case "subjects":
                return "/subjects";
            case "locations":
                return "/locations";
            default:
                return "/tutoring/".concat(ancestor.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageHero, {
                page: page
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "pt-lg-4",
                children: [
                    showBreadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "breadcrumb",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                            className: "breadcrumb bg-transparent px-0",
                            itemScope: true,
                            itemType: "https://schema.org/BreadcrumbList",
                            children: [
                                sortedAncestors.map((ancestor)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "breadcrumb-item",
                                        itemProp: "itemListElement",
                                        itemScope: true,
                                        itemType: "https://schema.org/ListItem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                            href: linkPath(ancestor),
                                            passHref: true,
                                            itemProp: "item",
                                            className: "text-decoration-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    itemProp: "name",
                                                    children: ancestor.linkTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                    itemProp: "position",
                                                    content: ancestor.cachedDepth + 1
                                                })
                                            ]
                                        })
                                    }, ancestor.id)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "breadcrumb-item active",
                                    "aria-current": "page",
                                    itemProp: "itemListElement",
                                    itemScope: true,
                                    itemType: "https://schema.org/ListItem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            itemProp: "name",
                                            children: page.linkTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                            itemProp: "position",
                                            content: page.cachedDepth + 1
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    page.body1Text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: page.body1Text
                                }
                            })
                        })
                    }),
                    page.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "mb-4",
                        children: page.children.map((child)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/tutoring/".concat(child.slug),
                                passHref: true,
                                className: "badge bg-secondary fw-normal text-decoration-none p-2 me-2 mb-2",
                                children: child.linkTitle
                            }, child.id))
                    }),
                    children,
                    page.body2Text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: page.body2Text
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LandingPageHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function LandingPageHead(param) {
    let { page  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: page.pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: page.metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:title",
                content: page.pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: page.metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: page.pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: page.metaDescription
            })
        ]
    });
}


/***/ }),

/***/ 38132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TutorSearchResultsList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
;// CONCATENATED MODULE: ./components/TutorProfileSubjectList.js


function TutorProfileSubjectList(param) {
    let { tutorProfile , subjects  } = param;
    const subjectsCount = subjects.length;
    const truncateLimit = 6;
    const truncatedSubjects = (()=>{
        return subjects.slice(0, truncateLimit);
    })();
    const isTruncated = subjectsCount > truncateLimit;
    const excludedSubjectsCount = subjectsCount - truncateLimit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-flex flex-wrap",
        children: [
            truncatedSubjects.map((subject)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "me-2 mb-2 p-2 bg-light rounded",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "small",
                        children: subject.name
                    })
                }, subject.id)),
            isTruncated && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mb-2 p-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "small",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "/tutors/".concat(tutorProfile.slug),
                        passHref: true,
                        children: [
                            "+",
                            excludedSubjectsCount,
                            "more"
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/TutorProfileRate.js

function TutorProfileRate(param) {
    let { subject , level , subjectLevels , modality  } = param;
    const subjectAndLevelPresent = !!((subject === null || subject === void 0 ? void 0 : subject.slug) && (level === null || level === void 0 ? void 0 : level.slug));
    const subjectLevel = (()=>{
        return subjectLevels.find((subjectLevel)=>{
            const otherSubject = subjectLevel.subject;
            const otherLevel = subjectLevel.level;
            if (subject && level) {
                return otherSubject.id === subject.id && otherLevel.id === level.id;
            } else if (subject) {
                return otherSubject.id === subject.id;
            } else if (level) {
                return otherLevel.id === level.id;
            }
        });
    })();
    const rateAttr = modality === "inPerson" ? "inPersonRate" : "onlineRate";
    const formattedRateAttr = rateAttr === "inPersonRate" ? "formattedInPersonRate" : "formattedOnlineRate";
    const lowestRate = (()=>{
        const filteredSubjectLevels = subjectLevels.filter((subjectLevel)=>!!subjectLevel[rateAttr]);
        const sorted = filteredSubjectLevels.sort((a, b)=>a[rateAttr] - b[rateAttr]);
        return sorted && sorted[0] && sorted[0][formattedRateAttr];
    })();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: subjectAndLevelPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: subjectLevel[formattedRateAttr]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: "from "
                }),
                lowestRate
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/tutorProfile/Rating.js
var Rating = __webpack_require__(79963);
// EXTERNAL MODULE: ./components/TutorSearchResultsRow.module.scss
var TutorSearchResultsRow_module = __webpack_require__(55512);
var TutorSearchResultsRow_module_default = /*#__PURE__*/__webpack_require__.n(TutorSearchResultsRow_module);
;// CONCATENATED MODULE: ./components/TutorSearchResultsRow.js












function TutorSearchResultsRow(param) {
    let { tutorProfile , subject , level  } = param;
    const hasTaughtTenHours = (()=>{
        return tutorProfile.totalLessonMinutes > 600;
    })();
    const lessonHoursLabel = (()=>{
        const lessonHours = tutorProfile.totalLessonHours;
        if (!lessonHours) return;
        const roundedLessonHours = Math.ceil(lessonHours / 5) * 5;
        return "".concat(roundedLessonHours, "+");
    })();
    const showRating = tutorProfile.tutorReviewsCount > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 3,
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: tutorProfile.profilePicture.thumb.url,
                                className: "rounded",
                                width: 150,
                                height: 150,
                                alt: "Profile picture",
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "mb-2 mb-md-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-block d-md-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-md-flex mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                            className: "my-auto me-md-2 mb-2 mb-md-0 d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/tutors/".concat(tutorProfile.slug),
                                                    passHref: true,
                                                    children: tutorProfile.firstNameAndLastInitial
                                                }),
                                                showRating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((TutorSearchResultsRow_module_default()).ratingContainer, " ms-2"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                                        tutorProfile: tutorProfile,
                                                        showCount: false,
                                                        size: 20
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                    children: tutorProfile.tagLine
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileSubjectList, {
                                    tutorProfile: tutorProfile,
                                    subjects: tutorProfile.subjects
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 3,
                            className: "d-md-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mx-auto w-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons_index_es/* faPoundSign */.x_I,
                                                size: "lg",
                                                fixedWidth: true,
                                                className: "me-1 my-auto text-success"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "d-inline fs-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileRate, {
                                                    subject: subject,
                                                    level: level,
                                                    subjectLevels: tutorProfile.subjectLevels,
                                                    modality: "online"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-3 mb-3",
                                        children: [
                                            tutorProfile.averageRequestResponseTimeLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faPaperPlane */.XCy,
                                                        size: "lg",
                                                        fixedWidth: true,
                                                        className: "me-1 text-success"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Responds in ",
                                                            tutorProfile.averageRequestResponseTimeLabel
                                                        ]
                                                    })
                                                ]
                                            }),
                                            hasTaughtTenHours && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faStopwatch */.U$5,
                                                        size: "lg",
                                                        fixedWidth: true,
                                                        className: "me-1 text-success"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            lessonHoursLabel,
                                                            " hours taught"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/tutors/".concat(tutorProfile.slug),
                                                passHref: true,
                                                className: "mb-md-2 btn btn-outline-secondary d-block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faUser */.ILF,
                                                        className: "me-1"
                                                    }),
                                                    "View Profile"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/tutors/".concat(tutorProfile.slug, "/send-message"),
                                                passHref: true,
                                                className: "mb-md-2 btn btn-primary d-block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faComments */.lXL,
                                                        className: "me-1"
                                                    }),
                                                    "Send Message"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./public/images/computer-search.jpg
/* harmony default export */ var computer_search = ({"src":"/_next/static/media/computer-search.65fac5a8.jpg","height":428,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBRFBFCP/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECMUH/2gAMAwEAAhEDEQA/AJreya6e/i8zfjMTpdunDziIiGNsTEf/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/tutorSearch/Banner.js





function TutorSearchBanner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-md-flex rounded border bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow-1 p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-2 text-primary",
                        children: "Need a hand with your search?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "mb-3 text-muted",
                        children: "We can help you find the perfect tutor. Give us a call!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "phone-cta",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons_index_es/* faPhone */.j1w,
                                size: "lg",
                                className: "me-2 text-info"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "tel:+441509265623",
                                className: "text-primary",
                                children: "01509 265 623"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: computer_search,
                width: 350,
                height: "100%",
                alt: "We can help with your search",
                className: "rounded-right",
                style: {
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "cover",
                    objectPosition: "center"
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/TutorSearchResultsList.js



function TutorSearchResultsList(param) {
    let { results , subject , level  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: results.map((tutorProfile, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorSearchResultsRow, {
                            tutorProfile: tutorProfile,
                            subject: subject,
                            level: level
                        })
                    }, tutorProfile.id),
                    (index === 2 || index === results.length - 1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorSearchBanner, {})
                    })
                ]
            }))
    });
}


/***/ }),

/***/ 79963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TutorProfileRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_simple_star_rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13773);


function TutorProfileRating(param) {
    let { tutorProfile , showCount =true , size =25  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_star_rating__WEBPACK_IMPORTED_MODULE_1__/* .Rating */ .i, {
                initialValue: tutorProfile.averageClientRating,
                readonly: true,
                allowHalfIcon: true,
                size: size
            }),
            showCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("em", {
                className: "small",
                children: [
                    "(",
                    tutorProfile.tutorReviewsCount,
                    " reviews)"
                ]
            })
        ]
    });
}


/***/ }),

/***/ 27987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_LandingPageContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86651);
/* harmony import */ var _components_TutorSearchResultsList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38132);
/* harmony import */ var _components_LandingPageHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1979);




function TutoringShow(param) {
    let { page , tutorSearch  } = param;
    var ref, ref1, ref2, ref3;
    const { results: tutorSearchResults , meta: tutorSearchMeta  } = tutorSearch;
    const tutorSearchRecordCount = tutorSearchMeta["record-count"];
    const hasSearchResults = tutorSearchRecordCount > 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LandingPageHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                page: page
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LandingPageContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                page: page,
                children: page.showSearchResults && hasSearchResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mb-5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "fw-bold",
                            children: [
                                tutorSearchRecordCount,
                                " ",
                                (ref = page.level) === null || ref === void 0 ? void 0 : ref.name,
                                " ",
                                (ref1 = page.subject) === null || ref1 === void 0 ? void 0 : ref1.name,
                                " ",
                                "tutors available."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "Here are some of the top ",
                                (ref2 = page.level) === null || ref2 === void 0 ? void 0 : ref2.name,
                                " ",
                                (ref3 = page.subject) === null || ref3 === void 0 ? void 0 : ref3.name,
                                " tutors."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TutorSearchResultsList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            results: tutorSearchResults,
                            subject: page.subject,
                            level: page.level
                        })
                    ]
                })
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (TutoringShow);


/***/ }),

/***/ 2231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageHero_container__EvdJl","overlay":"LandingPageHero_overlay__c7zRq","image":"LandingPageHero_image__iHXo4","staticBg":"LandingPageHero_staticBg__hxVj7","content":"LandingPageHero_content__fi9qn","searchContainer":"LandingPageHero_searchContainer__Mvx9i","btn":"LandingPageHero_btn__1kSW3"};

/***/ }),

/***/ 55512:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"TutorSearchResultsRow_ratingContainer__d3C9j"};

/***/ }),

/***/ 2086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  vertical: false,
  role: 'group'
};
const ButtonGroup = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  size,
  vertical,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...rest
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn-group');
  let baseClass = prefix;
  if (vertical) baseClass = `${prefix}-vertical`;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...rest,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, baseClass, size && `${prefix}-${size}`)
  });
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (ButtonGroup);

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 28984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35005);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








const noop = () => undefined;

const ToggleButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  name,
  className,
  checked,
  type,
  onChange,
  value,
  disabled,
  id,
  inputRef,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn-check');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", {
      className: bsPrefix,
      name: name,
      type: type,
      value: value,
      ref: inputRef,
      autoComplete: "off",
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange || noop,
      id: id
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { ...props,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, disabled && 'disabled'),
      type: undefined,
      role: undefined,
      as: "label",
      htmlFor: id
    })]
  });
});
ToggleButton.displayName = 'ToggleButton';
/* harmony default export */ __webpack_exports__["Z"] = (ToggleButton);

/***/ }),

/***/ 17954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41143);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(invariant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47150);
/* harmony import */ var _createChainedFunction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16833);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53439);
/* harmony import */ var _ButtonGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2086);
/* harmony import */ var _ToggleButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28984);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








const defaultProps = {
  type: 'radio',
  vertical: false
};
const ToggleButtonGroup = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const {
    children,
    type,
    name,
    value,
    onChange,
    ...controlledProps
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(props, {
    value: 'onChange'
  });

  const getValues = () => value == null ? [] : [].concat(value);

  const handleToggle = (inputVal, event) => {
    if (!onChange) {
      return;
    }

    const values = getValues();
    const isActive = values.indexOf(inputVal) !== -1;

    if (type === 'radio') {
      if (!isActive && onChange) onChange(inputVal, event);
      return;
    }

    if (isActive) {
      onChange(values.filter(n => n !== inputVal), event);
    } else {
      onChange([...values, inputVal], event);
    }
  };

  !(type !== 'radio' || !!name) ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ButtonGroup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { ...controlledProps,
    ref: ref,
    children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI)(children, child => {
      const values = getValues();
      const {
        value: childVal,
        onChange: childOnChange
      } = child.props;

      const handler = e => handleToggle(childVal, e);

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
        type,
        name: child.name || name,
        checked: values.indexOf(childVal) !== -1,
        onChange: (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(childOnChange, handler)
      });
    })
  });
});
ToggleButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(ToggleButtonGroup, {
  Button: _ToggleButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
}));

/***/ }),

/***/ 13773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(85893),o=__webpack_require__(67294);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(o),n=function(){return(n=Object.assign||function(e){for(var o,t=1,i=arguments.length;t<i;t++)for(var n in o=arguments[t])Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n]);return e}).apply(this,arguments)};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function r(e,o,t){if(t||2===arguments.length)for(var i,n=0,r=o.length;n<r;n++)!i&&n in o||(i||(i=Array.prototype.slice.call(o,0,n)),i[n]=o[n]);return e.concat(i||o)}function l(o){var t=o.size,i=void 0===t?25:t,r=o.strokeColor,l=void 0===r?"none":r,a=o.storkeWidth,c=void 0===a?0:a,s=o.className,u=void 0===s?"star-svg":s,d=o.style;return e.jsx("svg",n({fill:"currentColor",width:i,height:i,viewBox:"0 0 24 24",className:u,style:n({},d)},{children:e.jsx("path",{fill:"currentColor",stroke:l,strokeMiterlimit:"10",strokeWidth:c,d:"M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"},void 0)}),void 0)}var a=function(){return"ontouchstart"in window||navigator.maxTouchPoints>0};function c(e,o){switch(o.type){case"PointerMove":return n(n({},e),{hoverValue:o.payload});case"PointerLeave":return{defaultValue:e.defaultValue,hoverValue:null};case"MouseClick":return n(n({},e),{defaultValue:o.payload});default:return e}}exports.i=function(t){var s,u,d=t.onClick,v=t.initialValue,f=void 0===v?0:v,p=t.ratingValue,h=void 0===p?0:p,y=t.iconsCount,m=void 0===y?5:y,g=t.size,k=void 0===g?40:g,x=t.readonly,C=void 0!==x&&x,w=t.fillColor,b=void 0===w?"#ffbc0b":w,j=t.fillColorArray,M=void 0===j?[]:j,L=t.emptyColor,V=void 0===L?"#cccccc":L,N=t.fullIcon,P=void 0===N?null:N,A=t.emptyIcon,R=void 0===A?null:A,S=t.customIcons,z=void 0===S?[]:S,I=t.rtl,O=void 0!==I&&I,T=t.allowHalfIcon,q=void 0!==T&&T,B=t.allowHover,E=void 0===B||B,F=t.transition,H=void 0!==F&&F,W=t.className,_=void 0===W?"react-simple-star-rating":W,D=t.style,X=t.fullClassName,Y=void 0===X?"filled-icons":X,G=t.emptyClassName,J=void 0===G?"empty-icons":G,K=t.fullStyle,Q=t.emptyStyle,U=t.showTooltip,Z=void 0!==U&&U,$=t.tooltipDefaultText,ee=void 0===$?"Your Rate":$,oe=t.tooltipArray,te=void 0===oe?[]:oe,ie=t.tooltipClassName,ne=void 0===ie?"react-simple-star-rating-tooltip":ie,re=t.tooltipStyle,le=o.useReducer(c,{defaultValue:h,hoverValue:null}),ae=le[0],ce=ae.defaultValue,se=ae.hoverValue,ue=le[1];i.default.useEffect((function(){return ue({type:"MouseClick",payload:h})}),[h]);var de=function(e){var o=e.clientX,t=e.currentTarget.children[0].getBoundingClientRect(),i=t.left,n=t.right,r=t.width,l=function(e,o,t){for(var i=100/e,n=t/e,r=100,l=0;l<e;l+=1)if(o<=n*l+n/4){r=0===l&&o<n/2?0:i*l;break}return r}(he,O?n-o:o-i,r);l>0&&se!==l&&ue({type:"PointerMove",payload:l})},ve=function(){se&&(ue({type:"MouseClick",payload:se}),d&&d(se))},fe=o.useMemo((function(){return Math.round(f/m*100)}),[f,m]),pe=o.useMemo((function(){return E&&se&&se||ce&&ce||fe}),[E,se,ce,fe]),he=o.useMemo((function(){return q?2*m:m}),[q,m]),ye=o.useCallback((function(e){var o=1;return e&&(o=q?e/he:e/2/10),Math.round(o-1)}),[q,he]),me=o.useCallback((function(e){return q?e/2/10:ye(e)+1}),[q,ye]),ge=function(e){return te.length>0?te[ye(e)]:me(e)||0};return e.jsxs("span",n({style:{display:"inline-block",direction:"".concat(O?"rtl":"ltr"),touchAction:"none"}},{children:[e.jsxs("span",n({className:_,style:n({position:"relative",display:"inline-block",overflow:"hidden",whiteSpace:"nowrap",cursor:C?"":"pointer",verticalAlign:"middle",userSelect:"none"},D),onPointerMove:C?void 0:de,onPointerEnter:C?void 0:function(e){a()&&de(e)},onPointerLeave:C?void 0:function(){a()&&ve(),ue({type:"PointerLeave"})},onClick:C?void 0:ve,"aria-hidden":"true"},{children:[e.jsx("span",n({className:J,style:n({display:"inline-block",color:V},Q)},{children:r([],Array(m),!0).map((function(t,i){var n;return e.jsx(o.Fragment,{children:(null===(n=z[i])||void 0===n?void 0:n.icon)||R||e.jsx(l,{size:k},i)},i)}))}),void 0),e.jsx("span",n({className:Y,style:n((s={position:"absolute",top:0},s[O?"right":"left"]=0,s.color=E&&se&&M[ye(se)]||ce&&M[ye(ce)]||b,s.overflow="hidden",s.whiteSpace="nowrap",s.display="inline-block",s.transition=H?"width .2s ease, color .2s ease":"",s.width="".concat(pe,"%"),s),K),title:"".concat(se&&me(se)||me(fe)," out of ").concat(m)},{children:r([],Array(m),!0).map((function(t,i){var n;return e.jsx(o.Fragment,{children:(null===(n=z[i])||void 0===n?void 0:n.icon)||P||e.jsx(l,{size:k},void 0)},i)}))}),void 0)]}),void 0),Z&&e.jsx("span",n({className:ne,style:n((u={display:"inline-block",padding:"5px 15px",backgroundColor:"#333",color:"#fff"},u[O?"marginRight":"marginLeft"]=20,u.verticalAlign="middle",u.borderRadius=5,u),re)},{children:se&&ge(se)||ce&&ge(ce)||fe&&ge(fe)||ee}),void 0)]}),void 0)};
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,734,665,774,888,179], function() { return __webpack_exec__(78886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);